export default __webpack_public_path__ + "static/media/photo--lg--114.8f44fef7.jpg";